import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
    const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
    const token = tokenData.token || tokenData.accessToken;
    return {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
};

export const sendWhatsAppTest = async (phoneNumber = null, templateName = "hello_world", businessId = null, customerId = null) => {
    try {
        const payload = { 
            phoneNumber: phoneNumber || null, 
            templateName: templateName || "hello_world",
            businessId: businessId ? Number(businessId) : null,
            customerId: customerId ? Number(customerId) : null
        };
        const response = await axios.post(`${BASE_URL}/api/WhatsAppWebhook/send-test`, payload, {
            headers: getAuthHeader()
        });
        return response.data;
    } catch (error) {
        console.error("Error sending WhatsApp test:", error);
        throw error;
    }
};

export const getWhatsAppReplies = async () => {
    try {
        const response = await axios.get(`${BASE_URL}/api/WhatsAppWebhook/replies`, {
            headers: getAuthHeader()
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching WhatsApp replies:", error);
        throw error;
    }
};

export const clearWhatsAppReplies = async () => {
    try {
        const response = await axios.post(`${BASE_URL}/api/WhatsAppWebhook/clear`, {}, {
            headers: getAuthHeader()
        });
        return response.data;
    } catch (error) {
        console.error("Error clearing WhatsApp replies:", error);
        throw error;
    }
};
